import { Music } from "@hg/media"

import battleBgm from "../assets/audio/battle.mp3"
import bgm from "../assets/audio/bgm.mp3"
import gameBgm from "../assets/audio/game.mp3"

export const music = new Music({
    src: bgm,
    loop: true,
    autoPlay: true,
    fade: true,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})

export const gameMusic = new Music({
    src: gameBgm,
    loop: true,
    autoPlay: false,
    fade: true,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})

export const battleMusic = new Music({
    src: battleBgm,
    loop: true,
    autoPlay: false,
    fade: true,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})
